import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { MdViewHeadline } from "react-icons/md";
import Model from "../Model";
import moment from "moment";

const ViewDetailModel = ({ setViewDetail, selectedData }) => {
  const [detailType, setDetailType] = useState("1");
 
  const getStatus = (status) => {
    if (status === "SUCCESS") {
      return <Success>Success</Success>;
    } else {
      return <Failed>Failed</Failed>;
    }
    
  };

  const getPolice = (isPoliceVerificationEnabled) => {
    if (isPoliceVerificationEnabled === 1) {
      return <p>Yes</p>;
    } else {
      return <p>No</p>;
    }
  };

  const getId = (isIdVerificationEnabled) => {
    if (isIdVerificationEnabled === 1) {
      return <p>Yes</p>;
    } else {
      return <p>No</p>;
    }
  };

  const getGround = (isGroundIncluded) => {
    if (isGroundIncluded === 1) {
      return <p>Yes</p>;
    } else {
      return <p>No</p>;
    }
  };
  const getRent = (isRentAgreementEnabled) => {
    if (isRentAgreementEnabled === 1) {
      return <p>Yes</p>;
    } else {
      return <p>No</p>;
    }
  };

  const getProperty = (propId) => {
    if (propId) {
      return <PropertyId>#{propId}</PropertyId>;
    } else {
      return <p>N/A</p>;
    }
  };

  const getRentalBond = (bondPlan) => {
    if (bondPlan === 1) {
     return <p>Active</p>;
    } else if  (bondPlan === 2) {
      return <p>Inactive</p>;
    }else{
      return <p>N/A</p>;
    }
  };

  const getBondPaymnet = (isBondAvailable) => {
    if (isBondAvailable === 1) {
     return <p>Prepaid</p>;
    } else if  (isBondAvailable === 2) {
      return <p>Postpaid</p>;
    }else{
      return <p>N/A</p>;
    }
  };

  const getAgreement = (rentAgreementPath) => {
    if (rentAgreementPath) {
      return (
        <a
          href={selectedData.rentAgreementPath}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-primary-color text-sm"
        >
          Click Me
        </a>
      );
    }
  };

  const getSign = (signaturePath) => {
    if (signaturePath) {
      return (
        <a
          href={selectedData.signaturePath}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-primary-color text-sm"
        >
          Click Me
        </a>
      );
    }
  };

  const getType = (type) => {
    if (type == 1) {
      return <p>PG</p>;
    } else {
      return <p>Flat</p>;
    }
  };

  const getPrefrence = (tenantPrefrence) => {
    if (tenantPrefrence == 1) {
      return <p>Boy</p>;
    } else if (tenantPrefrence == 2) {
      return <p>Girl</p>;
    } else {
      return <p>Both</p>;
    }
  };

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setViewDetail}>
      <Wrapper>
        <Title>View Details</Title>
        <div className="flex my-4">
          <Status>{getProperty(selectedData?.propId) || "N/A"}</Status>
          <Status className="ml-3">
            {getStatus(selectedData?.status) || "N/A"}
          </Status>
        </div>

        <Column>
          <FirstColumn>
            <SubHeading>Owner Name</SubHeading>
            <Paragraph>{selectedData?.ownerFullName || "N/A"}</Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Client Id</SubHeading>
            <Paragraph>{selectedData?.clientId || "N/A"}</Paragraph>
          </SecondColumn>
        </Column>

        <Column>
          <FirstColumn>
            <SubHeading>Created At</SubHeading>
            <Paragraph>
              {moment(selectedData?.createdAt).format("LL") || "N/A"}
            </Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Updated At</SubHeading>
            <Paragraph>
              {moment(selectedData?.updatedAt).format("LL") || "N/A"}
            </Paragraph>
          </SecondColumn>
        </Column>

        <ButtonGroup>
          <TemplateButton
            isActive={detailType === "1"}
            onClick={() => setDetailType("1")}
          >
            Basic Details
          </TemplateButton>
          <TemplateButton
            isActive={detailType === "2"}
            onClick={() => setDetailType("2")}
          >
            Amenities
          </TemplateButton>
          <TemplateButton
            isActive={detailType === "3"}
            onClick={() => setDetailType("3")}
          >
            Bond Details
          </TemplateButton>
          
          <TemplateButton
            isActive={detailType === "4"}
            onClick={() => setDetailType("4")}
          >
            Bond Setting
          </TemplateButton>
        </ButtonGroup>
        <Seperator />

        <div className="h-[37vh] overflow-y-auto">
          {detailType === "1" && (
            <>
              <SingleItem name={"Eqaro ID"} value={selectedData?.eqaroId} />
              <SingleItem name={"Product ID"} value={selectedData?.productId} />
              <SingleItem
                name={"Property ID"}
                value={selectedData?.propertyId}
              />
              <SingleItem name="Visibility" value={selectedData?.visibility} />
              <SingleItem
                name="Approval Type"
                value={selectedData?.approvalType}
              />
              <SingleItem
                name={"Address"}
                value={selectedData?.address || "N/A"}
              />
              <SingleItem
                name="Property Age"
                value={selectedData?.propertyAge || 0}
              />
              <SingleItem
                name={"Bedrooms"}
                value={selectedData?.No_of_Bedrooms || "N/A"}
              />
              <SingleItem
                name={"Bathrooms"}
                value={selectedData?.noOfBathrooms || "N/A"}
              />
              <SingleItem
                name={"Unit Number"}
                value={selectedData?.numberOfUnits}
              />
            </>
          )}

          {detailType === "2" && (
            <>
              <SingleItem
                name="Aminities"
                value={selectedData?.amenities || "N/A"}
              />
            </>
          )}

          {detailType === "3" && (
            <>
              <SingleItem
                name="Expected Rent"
                value={selectedData?.expectedRent || "N/A"}
              />
              <SingleItem
                name="Expected Advance"
                value={selectedData?.expectedAdvanceRent || "N/A"}
              />
              <SingleItem
                name="Expected Bond"
                value={selectedData?.expectedBondValue || "N/A"}
              />
              <SingleItem
                name="Bond Fees"
                value={selectedData?.bondFees || "N/A"}
              />
              <SingleItem
                name="Bond Amount"
                value={selectedData?.bondAmount || "N/A"}
              />
            </>
          )}

              {detailType === "4" && (
               <>
              <SingleItem
                name="Rental Bond"
                value={getRentalBond(selectedData?.bondPlan) || "N/A"}
                />
                <SingleItem
                name="Bond Payment"
                value={getBondPaymnet(selectedData?.isBondAvailable) || "N/A"}
                />
            </>
          )}
        </div>
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value }) => (
  <div className="flex items-center py-1.5 border-b border-gray-100">
    <Name>{name}</Name> <p>:</p>
    <Value>
      {(name === "Security" || name === "Fine" || name === "Maintenance Fee") &&
        value !== "N/A" && <span className="mr-1">₹</span>}
      {value}
      {(name === "Agreement Period" ||
        name === "Notice Period" ||
        name === "Lock-In Period") && <span className="ml-1">months</span>}
      {name === "Grace Period" && <span className="ml-1">days</span>}
    </Value>
  </div>
);

const TemplateButton = ({ isActive, ml, ...rest }) => {
  return (
    <button
      className={`pl-0 pr-2 font-medium text-sm relative ${
        isActive ? "text-blue-500" : "text-gray-400"
      } ${
        ml ? "ml-4" : ""
      } after:absolute after:top-7 after:left-0 after:w-full after:h-0.5 ${
        isActive ? "after:bg-blue-500" : ""
      }`}
      {...rest} // Spread the remaining props onto the button element
    >
      {rest.children}
    </button>
  );
};

const Heading = tw.h1`text-2xl my-3 font-bold text-black text-left`;
const ButtonGroup = tw.div`flex items-center !gap-0 mt-6 space-x-4`;
const Seperator = tw.div`w-full h-[0.07rem] bg-gray-200 my-2 `;
const Status = tw.div``;
const Wrapper = tw.div`px-4`;
const Title = tw.h2`flex flex-row gap-2 text-lg md:text-xl text-gray-700 font-bold text-left`;
const Name = tw.p`text-sm text-gray-500  w-32`;
const Value = tw.p`text-sm text-black font-medium w-80 px-6 `;
const PropertyId = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Success = tw.div`bg-emerald-600 text-white text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Failed = tw.div`bg-rose-600 text-white text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;
export default ViewDetailModel;
